require('../../modules/es.array.find');

module.exports = require('../../internals/entry-unbind')('Array', 'find');
